import { Icon } from '@iconify/react';
import React, { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { Link as RouterLink } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import plusFill from '@iconify/icons-eva/plus-fill';
import QrCodeScannerOutlinedIcon from '@mui/icons-material/QrCodeScannerOutlined';
import DuoOutlinedIcon from '@mui/icons-material/DuoOutlined';
import DeviceHubOutlinedIcon from '@mui/icons-material/DeviceHubOutlined';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

import CampaignIcon from '@mui/icons-material/Campaign';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';



// material
import { Menu, MenuItem, IconButton, ListItemIcon, Box, ListItemText } from '@mui/material';
import { useAuth } from '../../customContextProviders/AuthContext';
import { APP_CONSTANTS } from '../../../URLConstants';

// ----------------------------------------------------------------------

export default function SoundBoxDeviceMoreMenu({ handleUser, handleClicks }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { sessionUserData } = useAuth()







  return (
    <Box >
      <IconButton data-testid='more-menu' ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >


        {/* 
         {
          handleUser?.device?.id !== undefined && handleUser?.device?.id !== null  && handleUser?.device?.id!=="" ?

            <MenuItem onClick={() =>{setIsOpen(false); handleClicks("remove_device")}} sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
              <RemoveCircleOutlineOutlinedIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Remove Device" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
            :

            <MenuItem onClick={() =>{setIsOpen(false); handleClicks("add")}} sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon  icon={plusFill} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Assign Device" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>

        } */}

        <MenuItem onClick={() => { setIsOpen(false); handleClicks("test_payment") }} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <CampaignIcon />
          </ListItemIcon>
          <ListItemText primary="Test Payment" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>


        <>
    {sessionUserData?.user?.role === APP_CONSTANTS?.L2_SUPPORT_USER_ROLE && (
      <Box data-testid="modal">
        {handleUser?.activated  ? (
          <MenuItem onClick={() => { setIsOpen(false); handleClicks("deactivate_device") }} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <RemoveCircleOutlineOutlinedIcon color='error' />
            </ListItemIcon>
            <ListItemText primary="De-Activate Device" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        ) : (
          <MenuItem onClick={() => { setIsOpen(false); handleClicks("activate_device") }} sx={{ color: 'text.secondary' }}>
            <ListItemIcon>
              <AddBusinessIcon />
            </ListItemIcon>
            <ListItemText primary="Activate Device" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Box>
    )}
  </>

{/* 
        {
          sessionUserData?.user?.role === APP_CONSTANTS?.L2_SUPPORT_USER_ROLE ?

          handleUser?.deviceid!==null && handleUser?.deviceid!=="" ? 
            <MenuItem  onClick={() => { setIsOpen(false); handleClicks("deactivate_device") }} sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <RemoveCircleOutlineOutlinedIcon color='error' />
              </ListItemIcon>
              <ListItemText primary="De-Activate Device"  primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
              :
            <MenuItem  onClick={() => { setIsOpen(false); handleClicks("activate_device") }} sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <AddBusinessIcon />
              </ListItemIcon>
              <ListItemText primary="Activate Device"  primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
            :
            null

        } */}



        {/* <MenuItem onClick={() => handleClicks("edit_driver")} component={RouterLink} to="#" sx={{ color: 'text.secondary' }}> 
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Alert Device " primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>  */}


        {/* 
<MenuItem onClick={() => {setIsOpen(false); handleClicks("view_trips")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <DeviceHubOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="View Trips" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() =>{setIsOpen(false); handleClicks("export_report")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <DuoOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Export Report" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() =>{setIsOpen(false); handleClicks("report_issue")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <DuoOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Report Issue" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem onClick={() =>{setIsOpen(false); handleClicks("device_settings")}} sx={{ color: 'text.secondary' }}>
          <ListItemIcon>
            <DuoOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Device Settings" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem> */}


      </Menu>
    </Box>
  );
}
